export enum ScreenStatus {
    On = 'on',
    Off = 'off',
    Error = 'error',
    Archive = 'archive',
}
